import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

function configRoutes() {
    return [
        {
            path: '/',
            redirect: '/dashboard',
            name: 'Home',
            component: () => import('@/containers/DefaultContainer'),
            meta: { hideInBreadcrumb: true },
            children: [
                {
                    path: 'dashboard',
                    name: 'Dashboard',
                    component: () => import('@/views/Dashboard')
                },
                {
                    path: 'kategori',
                    name: 'Kategori',
                    component: () => import('@/views/kategori/Kategori')
                },
                {
                    path: 'model',
                    name: 'Model',
                    component: { render (c) { return c('router-view') } },
                    children: [
                        {
                            path: '',
                            component: () => import('@/views/model/ModelList')
                        },
                        {
                            path: ':id',
                            name: "Detail Model",
                            component: () => import('@/views/model/ModelDetail')
                        }
                    ]
                },
                {
                    path: 'log-stok',
                    name: 'Log Stok',
                    component: () => import('@/views/logs/LogStok')
                },
                {
                    path: 'order',
                    name: 'Order',
                    component: () => import('@/views/orders/Order')
                },
                {
                    path: 'invoice',
                    name: 'Invoice',
                    component: () => import('@/views/invoices/Invoice')
                },
                {
                    path: 'user',
                    name: 'Users',
                    component: () => import('@/views/users/User')
                },
            ]
        },
        {
            path: '/login',
            name: 'Login',
            component: () => import('@/views/Login')
        }
    ]
}

export default new Router({
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: configRoutes()
})
